import React, { useCallback, useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Input from "../ui/Input";
import Checkbox from "../ui/Checkbox";
import Label from "../ui/Label";
import Button from "../ui/Button";
import Space from "../ui/Space";
import InventoryPubstock from "./InventoryPubstock";
import { ROUTES } from "../utils/Routes";
import CustomersController from "../controllers/CustomersController";
import { createScreen } from "../hooks/createScreen";
import { calculateProfitMargin, calculateSellPrice, convertDiscountToInt, kbdEvent, requestClerkCode, requireLogin, save, showConfirm } from "../utils/Utils";
import DateField from "../ui/DateField";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import OtherConditions from "./OtherConditions";
import { order_structure } from "../data_structures/Stock";
import { getSignal } from "../App";
import PriceField from "../ui/PriceField";
import Table from "../ui/Table";
import InventoryReserve from "./InventoryReserve";



export default function InventoryOrders(props) {

    const {
        controller = "",
        route = ROUTES.INVENTORY.ORDERS,
        switchView = () => { },
        updateSellPrice = () => { },
        fetchExtra = () => { },
        signal = {},
        sell_price = 0,
        setFullData = () => { },
        fullData = {},
        callback = () => { },
        primary_code = "",
        condition_code = "",
        tab = "order",
        setState = () => { },
        state = {},
        togglePubstock = () => { },

    } = props;



    useEffect(() => {

        // if (loading || props.loading) { return; }
        const actions = [
            { key: KBD.ESCAPE, action: () => switchView("inventory", "inventory") },
            // { key: KBD.TAB, action: () => { handleKeyNavigation(KBD.TAB) } },
            // { key: KBD.COMMA, action: () => togglePubstock() },
            // { key: KBD.SHIFT_TAB, action: () => handleKeyNavigation(KBD.SHIFT_TAB) },
            // { key: KBD.ARROW_UP, action: () => handleKeyNavigation(KBD.ARROW_UP) },
            // { key: KBD.ARROW_DOWN, action: () => handleKeyNavigation(KBD.ARROW_DOWN) },
            // { key: KBD.ARROW_LEFT, action: () => { switchView("history", "history") } },

            // { key: KBD.PAGE_DOWN, action: () => save() },
            // { key: KBD.SHIFT_ENTER, action: () => handleKeyNavigation(KBD.SHIFT_TAB) },
            // { key: KBD.H, action: () => switchView("history", "history") }

        ];
        const cleanup = listen(
            controller, route, actions, () => { }, [KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_LEFT, KBD.ARROW_RIGHT, KBD.ARROW_UP, KBD.ARROW_DOWN, KBD.ENTER, KBD.SHIFT_ENTER, KBD.ESCAPE, KBD.PAGE_DOWN, KBD.COMMA], [], []
        );
        return cleanup;
    }, [route]);



    return (
        <InventoryReserve
            tab={tab}
            state={state}
            setState={setState}
            controller={controller}
            switchView={switchView}
            updateSellPrice={updateSellPrice}
            fetchExtra={fetchExtra}
            signal={signal}
            sell_price={fullData?.stock?.price}
            setFullData={setFullData}
            fullData={fullData}
            callback={callback}
            primary_code={primary_code}
            condition_code={condition_code}
            togglePubstock={togglePubstock}
        />
    )
    
}